"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
export default function HeroBilingue() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const handleScrollToContact = () => {
    const contactSection = document.getElementById("contactez-nous");
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(220,80%,20%)] via-[hsl(220,50%,10%)] to-[hsl(220,90%,5%)]">
        {}
        <svg className="absolute inset-0 w-full h-full opacity-20" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="constellation" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
              <circle cx="20" cy="30" r="1.5" fill="white" opacity="0.8" />
              <circle cx="60" cy="50" r="1" fill="white" opacity="0.6" />
              <circle cx="100" cy="20" r="1.2" fill="white" opacity="0.7" />
              <circle cx="140" cy="70" r="1" fill="white" opacity="0.5" />
              <circle cx="180" cy="40" r="1.3" fill="white" opacity="0.75" />
              <line x1="20" y1="30" x2="60" y2="50" stroke="white" strokeWidth="0.5" opacity="0.3" />
              <line x1="60" y1="50" x2="100" y2="20" stroke="white" strokeWidth="0.5" opacity="0.3" />
              <line x1="100" y1="20" x2="140" y2="70" stroke="white" strokeWidth="0.5" opacity="0.3" />
              <line x1="140" y1="70" x2="180" y2="40" stroke="white" strokeWidth="0.5" opacity="0.3" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#constellation)" />
        </svg>

        {}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/60 to-transparent animate-[slide-right_8s_ease-in-out_infinite]" />
          <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-secondary/50 to-transparent animate-[slide-left_10s_ease-in-out_infinite]" />
          <div className="absolute top-3/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent animate-[slide-right_12s_ease-in-out_infinite]" />
        </div>
      </div>

      {}
      <div className={`relative z-10 mx-auto max-w-4xl px-6 transition-all duration-[200ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
        <div className="glass-effect p-12 text-center space-y-8 bg-transparent backdrop-blur-none border-transparent shadow-none">
          {}
          <div className="space-y-6">
            <div className="flex justify-center">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/image_bv9o3lqr.png" alt="NorthStar Advisory" className="h-[196px]" />
            </div>
            <div className="space-y-3">
              <p className="text-[1.5rem] leading-[1.4] font-semibold text-secondary">
                Notre métier : Accompagner les ESN dans la maîtrise de
                l'innovation, des évolutions organisationnelles et des enjeux
                capitalistiques
              </p>
            </div>
          </div>

          {}
          <div className="space-y-4 max-w-3xl mx-auto">
            <p className="text-muted-foreground"></p>
          </div>

          {}
          <div className="pt-4">
            <Button onClick={handleScrollToContact} className="btn-primary group">Démarrons Ensemble<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-chevron-down ml-2 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:translate-y-0.5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/HeroBilingue.tsx|sig:2bk1ga" data-ast-start="3820" data-ast-end="4320"><path d="m6 9 6 6 6-6" data-ast-id="f:/src/pages/Home/sections/HeroBilingue.tsx|sig:9sklf9" data-ast-start="4284" data-ast-end="4314"></path></svg></Button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-right {
          0%,
          100% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(100%);
          }
        }
        @keyframes slide-left {
          0%,
          100% {
            transform: translateX(100%);
          }
          50% {
            transform: translateX(-100%);
          }
        }
      `}</style>
    </section>;
}